import React, { Component } from 'react'
import "./signup.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiActivityForm , getApiUpload , getApiSetSignInfo } from '../../axios/api';
import { UrlSearch , get } from '../../axios/localstorage';

import {  DatePicker , message, TimePicker  } from 'antd';

import moment from 'moment';

import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const { MonthPicker , YearPicker } = DatePicker;

const dateFormat = 'YYYY-MM-DD';
const monthFormat = 'YYYY-MM';
const yearFormat = 'YYYY';

export default class signup extends Component {

    state = {
        page:1,
        total:1,
        list:[],
        id:"",
        isopen:true,
        name:"",
        alert:false,
        delAlert:false,
        param:[],
        index:0,
        num:0,
        edit:false,
    }

    componentWillMount(){
        window.scroll(0,0);

        let id = UrlSearch('id');
        this.setState({
            id
        })
        getApiActivityForm({id,token:get('token')})
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    list:req.data.data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    changePage=(page)=>{
        this.setState({
            page
        })

    }

    gotoAdd=(index)=>{
        let list = this.state.list;
        let array = JSON.stringify(list[index].array);
        this.setState({
            index,
            param:JSON.parse(array),
            alert:true,
            edit:false,
        })
        
    }

    confirmPush=()=>{
        let param = {
            token:get('token'),
            type:1,
            form:this.state.list,
            id:this.state.id
        }

        getApiSetSignInfo(param)
        .then( req =>{
            if(req.data.code === 1){
                message.success('提交成功');
            }else{
                message.info(req.data.msg);
            }
        })
    }

    confirmAdd=()=>{
        let list = this.state.list;
        let index = this.state.index;

        let param = this.state.param;

        if(list[index].list){
            list[index].list.push(param);
        }else{
            list[index].list = [];
            list[index].list.push(param);
        }

        console.log(param);
        console.log(list);

        this.setState({
            list,
            alert:false,
            param:[],
            name:"",
        })
    }

    confirmEdit=()=>{
        let list = this.state.list;
        let index = this.state.index;
        let num = this.state.num;

        let param = this.state.param;

        list[index].list[num] = param;

        this.setState({
            list,
            alert:false,
            param:[],
            name:"",
        })
    }

    gotoDel=()=>{

        let index = this.state.index;
        let num = this.state.num;

        let list = this.state.list;
        list[index].list.splice(num,1);
        console.log(list);


        this.setState({
            list,
            delAlert:false
        })
    }

    gotoEdit=(index,num)=>{
        let list = this.state.list;

        let json = JSON.stringify(list[index].list[num]);


        this.setState({
            param:JSON.parse(json),
            edit:true,
            index:index,
            num:num,
            alert:true,
        })
    }

    gotoChooseCheckBox=(index,num)=>{
        let param = this.state.param;
        let list = param[index].list;
        

        if(list[num].type ==='1'){
            list[num].type = '0';
        }else{
            list[num].type = '1';
        }

        let nameArr = [];

        for(var i=0;i<list.length;i++){
            if(list[i].type === "1"){
                nameArr.push(list[i].name)
            }
        }

        console.log(nameArr);

        param[index].list = list;
        param[index].value = nameArr.join(',');

        this.setState({param})
    }

    gotoChooseRadio=(index,num)=>{
        let param = this.state.param;
        let list = param[index].list;
        for(var i=0;i<list.length;i++){
            list[i].type = '0'
        }

        list[num].type = '1';

        param[index].list = list;
        param[index].value = list[num].name

        console.log(list);
        console.log(param);
        


        this.setState({param})
    }

    gotoLoad=(event,index)=>{

        let file = event.target.files[0];
        console.log(file);
        let name = file.name;;
        console.log(name);
        let fd = new FormData()
    
        fd.append('file', file)
        // fd.append('token', get('token'));
        // fd.append('type',2);

        getApiUpload(fd)
        .then( req =>{
            console.log(req.data);
            if(req.data.code === 1){

                

                let data = req.data.data;
                let param = this.state.param;
                param[index].value = data.url;
                param[index].valueName = name;
                this.setState({
                    param
                })


            }
        }).catch( err =>{
            console.error(err)
        })

    }

    render() {
        return (
            <div className='signup'>
                <Header type={8} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p className='i_point' onClick={()=>{this.gotoPage('/activity')}}>科创活动</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>在线报名</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page'>
                    <div className='cen'>
                        <div className='main'>
                           {
                               this.state.list.map((item,index)=>{
                                   return <div className='box' key={index}>
                                                <div className='name'>
                                                    <h2>{item.name}</h2>
                                                    <button onClick={()=>{this.gotoAdd(index)}}>添加</button>
                                                </div>
                    
                                                <table>
                                                    <tr className='tr2'>
                                                        {
                                                            item.array.map((elem,num)=>{
                                                                return <th>{elem.name}</th>
                                                            })
                                                        }
                                                        <th className='tw2'>操作</th>
                                                    </tr>
                                                    {
                                                        item.list.map((elem,num)=>{
                                                            return <tr key={elem}>
                                                                        {
                                                                            elem.map((e,n)=>{
                                                                                return <td>{e.type === "file"?e.valueName:e.value}</td>
                                                                            })
                                                                        }
                                                                        
                                                                        <td>
                                                                            <div className='option'>
                                                                                <h2 onClick={()=>{this.gotoEdit(index,num)}}>修改</h2>
                                                                                <span></span>
                                                                                <p onClick={()=>{this.setState({index,num,delAlert:true})}}>删除</p>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                        })
                                                    }
                                                </table>
                                            </div>
                               })
                           }
                        </div>
                        
                    </div>
                    <div className='cen'>
                        <button className='abtn' onClick={()=>{this.confirmPush()}}>确认提交</button>
                    </div>
                </div>

                <div className='alert' hidden={!this.state.alert}>
                    <div className='abox'>
                        <div className='name'>
                            <h2>主导产业集聚度</h2>
                            <img alt="" onClick={()=>{this.setState({alert:false})}} src="/www/assets/imgs/chacha.png" className='aclose' />
                        </div>

                        <div className='box'>
                            {
                                this.state.param.map((item,index)=>{
                                    return <div key={index}>
                                                <div className='aitem' hidden={item.type !== 'input'}>
                                                    <h2>{item.name}</h2>
                                                    <input type="text" value={item.value} onChange={(ev)=>{
                                                        let value = ev.target.value;
                                                        let param = this.state.param;
                                                        param[index].value = value;
                                                        this.setState({
                                                            param
                                                        })
                                                    }} /> 
                                                </div>
                                                <div className='aitem' hidden={item.type !== 'number'}>
                                                    <h2>{item.name}</h2>
                                                    <input type="number" value={item.value} onChange={(ev)=>{
                                                        let value = ev.target.value;
                                                        let param = this.state.param;
                                                        param[index].value = value;
                                                        this.setState({
                                                            param
                                                        })
                                                    }} /> 
                                                </div>
                                                <div className='aitem' hidden={item.type !== 'file'}>
                                                    <h2>{item.name}</h2>
                                                    <div className='aload'>
                                                        <div>上传<input value="" className='load' onChange={(ev)=>{this.gotoLoad(ev,index)}} type="file" accept="*" id="inputFile"  /></div>
                                                        <p>{item.valueName}</p>
                                                    </div>
                                                </div>
                                                <div className='aitem' hidden={item.type !== 'date'}>
                                                    <h2>{item.name}</h2>
                                                    <div className='aipt'>{item.value}
                                                    <DatePicker 
                                                    onChange={(value,selectedOptions)=>{
                                                        console.log(value);
                                                        console.log(selectedOptions);

                                                        let param = this.state.param;
                                                        param[index].value = selectedOptions;
                                                        this.setState({
                                                            param
                                                        })
                                                    }} 
                                                    style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%",height:"100%",position:"absolute",top:"0",left:"0"}} 
                                                    placeholder=' ' size="large"  />
                                                    </div>
                                                </div>
                                                <div className='aitem' hidden={item.type !== 'year'}>
                                                    <h2>{item.name}</h2>
                                                    <div className='aipt'>{item.value}
                                                    <YearPicker 
                                                    onChange={(value,selectedOptions)=>{
                                                        console.log(value);
                                                        console.log(selectedOptions);
                                                        let param = this.state.param;
                                                        param[index].value = selectedOptions;
                                                        this.setState({
                                                            param
                                                        })
                                                    }} 
                                                    mode="year"
                                                    format={yearFormat}
                                                    style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%",height:"100%",position:"absolute",top:"0",left:"0"}} 
                                                    placeholder=' ' size="large"  />
                                                    </div>
                                                </div>
                                                <div className='aitem' hidden={item.type !== 'month'}>
                                                    <h2>{item.name}</h2>
                                                    <div className='aipt'>{item.value}
                                                    <MonthPicker 
                                                    // locale={locale}
                                                    style={{borderColor:'#fff',flex:'1',opacity:'0',width:"100%",height:"100%",position:"absolute",top:"0",left:"0"}} placeholder=' ' size="large"
                                                    onChange={(value,selectedOptions)=>{
                                                        console.log(value);
                                                        console.log(selectedOptions);
                                                        let param = this.state.param;
                                                        param[index].value = selectedOptions;
                                                        this.setState({
                                                            param
                                                        })
                                                    }} 
                                                    format={monthFormat} />
                                                    </div>
                                                </div>
                                                <div className='adiv' hidden={item.type !== 'textarea'}>
                                                    <h2>{item.name}</h2>
                                                    <textarea type="text" value={item.value} onChange={(ev)=>{
                                                        let value = ev.target.value;
                                                        let param = this.state.param;
                                                        param[index].value = value;
                                                        this.setState({
                                                            param
                                                        })
                                                    }}></textarea> 
                                                </div>
                                                <div className='adiv' hidden={item.type !== 'radio'}>
                                                    <h2>{item.name}</h2>
                                                    <div className='aradio'>
                                                        {
                                                            item.list.map((elem,num)=>{
                                                                return <div className='ari' key={num}>
                                                                            <div className='ar_chose' onClick={()=>{this.gotoChooseRadio(index,num)}}>
                                                                                <div hidden={elem.type === '0'}></div>
                                                                            </div>
                                                                            <p>{elem.name}</p>
                                                                        </div>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className='adiv' hidden={item.type !== 'checkbox'}>
                                                    <h2>{item.name}</h2>
                                                    <div className='aradio'>
                                                        {
                                                            item.list.map((elem,num)=>{
                                                                return <div className='acheckbox'>
                                                                            <div className='ar_chose' onClick={()=>{this.gotoChooseCheckBox(index,num)}}>
                                                                                <div hidden={elem.type === '0'}></div>
                                                                            </div>
                                                                            <p>{elem.name}</p>
                                                                        </div>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                        </div>
                                })
                            }
                            

                            <div className='cen' hidden={this.state.edit}>
                                <button className='abtn' onClick={()=>{this.confirmAdd()}}>确认添加</button>
                            </div>
                            <div className='cen' hidden={!this.state.edit}>
                                <button className='abtn' onClick={()=>{this.confirmEdit()}}>确认修改</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='alert' hidden={!this.state.delAlert}>
                    <div className='adel'>
                        <h1>提示</h1>
                        <p>您确定要删除此项吗？</p>
                        <div className='abtns'>
                            <button className='btn1' onClick={()=>{this.setState({delAlert:false})}}>取消</button>
                            <button className='btn2' onClick={()=>{this.gotoDel()}}>确定</button>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}

